
'use client'
import { Suspense, useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import style from "./page.module.css"
import Loader from "./Components/Hero/Loader/Loader.jsx";
import Motto from "./Components/Hero/Motto/Motto";
import MobileMotto from "./Components/Hero/MobileMotto/MobileMotto";
import Hero from './Components/Hero/MainHero/Hero';
import Layout from './Components/Layout/Layout';
import useLoaderLogic from './Components/Hero/Loader/loader.func';
import gsap from 'gsap';
import CartTicket from './Components/Navbar/CartTicket';
// Use dynamic imports but keep SSR for GSAP animations to work properly
const Listing = dynamic(() => import("./Components/Listing.jsx/Listing"), {
  loading: () => <ComponentLoader name="Products" />,
  ssr: true // Keep SSR for GSAP ScrollTrigger
});

const Reviews = dynamic(() => import("./Components/Reviews/Reviews"), {
  loading: () => <ComponentLoader name="Reviews" />,
  ssr: true // This can stay client-side only
});



// Loading fallback component
function ComponentLoader({ name }) {
  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#fff',
      fontSize: '1.2rem',
      background: '#000'
    }}>
      Loading {name}...
    </div>
  );
}

export default function Home() {
  const [isMobile, setIsMobile] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    // Check if loader has been shown in this session
    const hasSeenLoader = sessionStorage.getItem('hasSeenLoader');

    if (hasSeenLoader) {
      // Skip loader if already seen
      setIsVisible(false);
if (!isMobile) {
      const ctx = gsap.context(() => {
        const tl = gsap.timeline({});
        const navbar = document.querySelector('#navbar');
        tl.to('.Main_motto',{autoAlpha:1,ease:"back.in"})
        if (navbar) {

          tl.fromTo('#navbar',
            { autoAlpha: 0, visibility: 'visible' },
            { autoAlpha: 1, ease: 'sin.in', duration: 2 },
            'a'
          );
        }

        // Animate motto elements if they exist (for desktop)
        const mottoText = document.querySelector('.mottoText');
        const model3D = document.querySelector('.model3D');
        const canvas = document.querySelector('#canvas');

        if (mottoText) {
          tl.to(".mottoText", { transform: 'translate3D(0,0,0)', duration: 1.5,autoAlpha:1 }, "a");
        }
        if (model3D) {
          tl.to(".model3D", { autoAlpha: 1, duration: 1.5 }, "a");
        }
        if (canvas) {
          tl.fromTo("#canvas", {
            autoAlpha: 0,
            transform: "translate3D(0,10vh,0)"
          }, {
            autoAlpha: 1,
            transform: "translate3D(0,0,0)"
          }, "a");
        }
      })

      return () => { window.removeEventListener('resize', checkMobile); ctx.revert() }
   }
    }
    else {
      setIsVisible(true);
      sessionStorage.setItem('hasSeenLoader', 'true');
      return () => { window.removeEventListener('resize', checkMobile) }

    }

  }, []);

  return (
    <Layout>
     <CartTicket/>
      <div className={style.App__mainContainer}>
        {/* Hero section with loader and motto - critical above-the-fold content */}
        <header>
          {isVisible && <Loader />}
          {isMobile ? <div><MobileMotto isVisible={isVisible} /> <Hero /> </div> : <Motto />}
        </header>

        {/* Main content area - with proper Suspense for GSAP components */}
        <main>
          <Suspense fallback={<ComponentLoader name="Products" />}>
            <Listing />
          </Suspense>

          <Suspense fallback={<ComponentLoader name="Reviews" />}>
            <Reviews />
          </Suspense>
        </main>
      </div>
    </Layout>
  );
}
